export const CATEGORY: string = 'Auth';
